import React, { ReactNode } from 'react';

import { DavAddressBookContact } from 'jamespot-user-api';
import { useIntl } from 'react-intl';
import { JRCTypography } from '../../JRCTypography/JRCTypography';

import { Container, ContactImg, CSSContactItemA, CSSContactItem } from './styles';

export type JRCWidgetContactCardDavProps = { contactCardList: DavAddressBookContact[] };

export const JRCWidgetContactCardDav = ({ contactCardList }: JRCWidgetContactCardDavProps) => {
    const intl = useIntl();
    return (
        <Container>
            {contactCardList.length
                ? contactCardList.map((contact, index) => {
                      return (
                          <ContactItem key={`contact-card-${index}`} contact={contact}>
                              <ContactImg color={contact.imageColor}>{contact.initial}</ContactImg>
                              <JRCTypography size="m">{contact.fullName}</JRCTypography>
                          </ContactItem>
                      );
                  })
                : intl.formatMessage({ id: 'GLOBAL_No_Result' })}
        </Container>
    );
};

export const ContactItem = ({ contact, children }: { contact: DavAddressBookContact; children: ReactNode }) => {
    return contact.url ? (
        <CSSContactItemA href={contact.url} aria-label={contact.fullName} target="_blank" rel="noreferrer">
            {children}
        </CSSContactItemA>
    ) : (
        <CSSContactItem>{children}</CSSContactItem>
    );
};
